export default __webpack_public_path__ + "static/media/instagram.64e70857.svg";